import { Tag } from "antd";
import { OrderPaymentConst } from "states/order/order.models";

export interface IOrderPaymentStatusTagProps {
  status: string;
}

export function OrderPaymentStatusTag(props: IOrderPaymentStatusTagProps) {
  switch (props.status) {
    case OrderPaymentConst.status.pending:
      return (
        <Tag style={{ marginRight: 0 }} color="processing">
          Đợi thanh toán
        </Tag>
      );

    default:
      return (
        <Tag style={{ marginRight: 0 }} color="success">
          Hoàn tất
        </Tag>
      );
  }
}
